<template>
    <fragment>
        <div image-fill class="container section-inner illustration-section-01">
            <br/><br/>
            <h3 v-html="title" style="text-align:center;"></h3>
            <div v-html="content" style="padding:20px;"></div>
        </div>
        
        <c-cta top-divider bottom-divider split />
    </fragment>
</template>

<script>
import CLayout from '@/layouts/LayoutDefault.vue'
import CCta from '@/components/sections/Cta.vue'
import marked from 'marked'

export default {
  name: 'Home',
  components: {
    CCta
  },
   data () {
    return {
        title: '',
       content: ''
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
    this.GetDetail();
  },
  watch:{
    $route(){
        this.GetDetail();
    }
},
methods: {
   GetDetail() {
        let str = window.location.search
        let type = str.substr(str.indexOf('=')+1,1)
        let id = str.substr(str.lastIndexOf('=')+1)
        this.$axios.get("https://system.line-1.com/openapi/CMS/GetNewsOrHelpById",
        {
            params:{
                id: id,
                type: type,
            }
        }).then((res) => {
            window.console.log(res)
            if(res.data.success){
                this.title = marked(res.data.data.data.title)
                this.content = marked(res.data.data.data.content)
            }
        });
   }
}
}
</script>